import css from '@emotion/css';
import styled from '@emotion/styled';

export const fadeIn = css`
  animation: fadeIn 0.4s ease;

  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
`;

export const ModalContainer = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* animation */
  ${fadeIn}
`;

export const Overlay = styled('div')`
  background-color: dimgrey;
  width: 100%;
  height: 100%;
  opacity: 0.5;
`;
